import React from "react";
import {
  MI_DOCUMENT_REVIEW_STEP,
  MISSING_PATIENT_DEMO_SUBSTATUS,
  NO_DOCS_CLINICAL_INFO_OR_DEMOGRAPHICS_SUBSTATUS,
  LAB_FOLLOWUP_STEPS,
  MI_SALESFORCE_MESSAGE_STEP,
  MI_ALREADY_CONTACTED_LAB_STEP,
  MI_NEED_CONTACT_LAB_STEP,
} from "./screens/missinginfo_steps";
import { Wizard } from "./Wizard";
import { initialLabAnswers } from "./MissingInfoFollowupWizard";

export const LabFollowupWizard = ({
  caseId,
  caseUrl,
  commentsUrl,
  labTests,
  caseData,
  statusUrl,
  assigneeUrl,
  snoozeUrl,
  tasksUrl,
  nextStepUrl,
  submitUrl,
  miInfoUrl,
  missingFields,
  recordMiSalesforceContactUrl,
  createMiContactAttempt,
  updateCase,
  loading,
  moveToStepUrl,
  substatus,
  hasSupplementalDocuments,
  alreadyContacted,
}) => {
  let initialAnswers = _.clone(initialLabAnswers);
  let initialStep = MI_NEED_CONTACT_LAB_STEP;

  if (missingFields) {
    initialAnswers.missingInfoFields = missingFields;
  }

  if (substatus) {
    initialAnswers.substatus = substatus;
  }

  if (
    (substatus === MISSING_PATIENT_DEMO_SUBSTATUS || substatus === NO_DOCS_CLINICAL_INFO_OR_DEMOGRAPHICS_SUBSTATUS) &&
    hasSupplementalDocuments
  ) {
    initialStep = MI_DOCUMENT_REVIEW_STEP;
  }

  if (alreadyContacted) {
    initialStep = MI_ALREADY_CONTACTED_LAB_STEP;
  }

  return (
    <Wizard
      name="Missing Info Lab Followup"
      initialStep={initialStep}
      initialAnswers={initialAnswers}
      caseId={caseId}
      steps={LAB_FOLLOWUP_STEPS}
      caseUrl={caseUrl}
      commentsUrl={commentsUrl}
      labTests={labTests}
      caseData={caseData}
      statusUrl={statusUrl}
      assigneeUrl={assigneeUrl}
      snoozeUrl={snoozeUrl}
      tasksUrl={tasksUrl}
      nextStepUrl={nextStepUrl}
      submitUrl={submitUrl}
      miInfoUrl={miInfoUrl}
      missingFields={missingFields}
      createMiContactAttempt={createMiContactAttempt}
      updateCase={updateCase}
      recordMiSalesforceContactUrl={recordMiSalesforceContactUrl}
      loading={loading}
      moveToStepUrl={moveToStepUrl}
    />
  );
};
